// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".week-timeline .day-timeline-width{width:175px;-ms-flex-negative:0;flex-shrink:0}", ""]);
// Exports
module.exports = exports;
